
import { FileQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function CourseNotFound() {
  const navigate = useNavigate();

  return (
    <div className="p-8 flex flex-col items-center justify-center h-96">
      <FileQuestion className="h-16 w-16 text-muted-foreground mb-4" />
      <h2 className="text-2xl font-bold mb-2">Course not found</h2>
      <p className="text-muted-foreground mb-6 text-center">
        The course you're looking for may have been removed or you don't have permission to view it.
      </p>
      <Button onClick={() => navigate('/admin/courses')}>
        Return to Courses
      </Button>
    </div>
  );
}
